module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "aria-labelledby": "headertrans01",
      "epub:type": "frontmatter",
      "id": "trans"
    }
  }, [_c('header', {
    attrs: {
      "id": "headertrans01"
    }
  }, [_c('h1', {
    staticClass: "ctfm"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": " Page ix. ",
      "epub:type": "pagebreak",
      "id": "pix",
      "role": "doc-pagebreak"
    }
  }), _c('a', {
    staticClass: "xref",
    attrs: {
      "href": "#/chifoucaultcritique0006#rtrans"
    }
  }, [_vm._v("Translator’s Note")])])]), _vm._v(" "), _c('p', {
    staticClass: "pf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "data-locator": "pix"
    }
  }), _vm._v("I have provided references to existing English translations of works cited in the French edition. For references to works by Foucault that are collected in "), _c('i', [_vm._v("Dits et Écrits")]), _vm._v(", I have included in parentheses the numeration used by these volumes to assist readers in cases where multiple English translations exist and for readers working in languages other than English. For items that have not been translated into English, I have provided the volume number and page from "), _c('i', [_vm._v("Dits et Écrits")]), _vm._v(".")]), _vm._v(" "), _c('p', [_vm._v("I have followed translation practices in other works by Foucault and translated Foucault’s own words in his references to classical Greek and Roman literature. Passages of such literature in quotation marks in the lectures are usually paraphrases by Foucault, and any direct citations are to French translations or Foucault’s own translations, which are sometimes quite different from the English translations of classical literature. I have consulted the digital Loeb Classical Library and a number of more recent English translations from the Greek and Latin for this English edition.")]), _vm._v(" "), _c('p', {
    staticClass: "patr"
  }, [_vm._v("Clare O’Farrell")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-90d7996e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-foucault-critique-0008.vue
// module id = 75
// module chunks = 0